import { Grid, Skeleton } from '@mui/material'
import React from 'react'

const ProfileFormStepLoader = () => {
  return (
    <Grid>
      <Skeleton height={38} variant="rectangular" sx={{ mb: '32px' }} />
      <Skeleton height={48} variant="rectangular" sx={{ mb: '16px' }} />
      <Skeleton height={400} variant="rectangular" />
    </Grid>
  )
}

export default ProfileFormStepLoader
